import type { GridGuideSettings, PageGuideSettings } from '@/components/canvas/document/publicTypes';

/** 栅格列数：min 0 · max 16 · default 4 · step 2 */
export const GRID_COLUMNS = { min: 0, max: 16, default: 4, step: 2 } as const;
/** 栅格行数：min 0 · max 16 · default 0 · step 2 */
export const GRID_ROWS = { min: 0, max: 16, default: 0, step: 2 } as const;
/** 栅格间距：min 0 · max 120 · default 12 · step 12 */
export const GRID_GUTTER = { min: 0, max: 120, default: 12, step: 12 } as const;
/** 栅格边距：min 0 · max 120 · default 12 · step 12 */
export const GRID_MARGIN = { min: 0, max: 120, default: 12, step: 12 } as const;

export const DEFAULT_GRID_GUIDE_SETTINGS: GridGuideSettings = {
  columns: GRID_COLUMNS.default,
  rows: GRID_ROWS.default,
  gutter: GRID_GUTTER.default,
  margin: GRID_MARGIN.default,
};

export const DEFAULT_PAGE_GUIDE_SETTINGS: PageGuideSettings = {
  enabled: false,
  system: 'grid',
  grid: DEFAULT_GRID_GUIDE_SETTINGS,
};

/** 补全局部 grid 字段，避免 columns 等为 undefined 时不画列线 */
export function normalizeGridGuideSettings(
  grid: Partial<GridGuideSettings> | undefined,
): GridGuideSettings {
  return {
    columns: grid?.columns ?? DEFAULT_GRID_GUIDE_SETTINGS.columns,
    rows: grid?.rows ?? DEFAULT_GRID_GUIDE_SETTINGS.rows,
    gutter: grid?.gutter ?? DEFAULT_GRID_GUIDE_SETTINGS.gutter,
    margin: grid?.margin ?? DEFAULT_GRID_GUIDE_SETTINGS.margin,
  };
}

export function resolvePageGuideSettings(
  page: { guideSettings?: PageGuideSettings } | null | undefined,
): PageGuideSettings {
  const raw = page?.guideSettings ?? DEFAULT_PAGE_GUIDE_SETTINGS;
  return {
    enabled: raw.enabled ?? DEFAULT_PAGE_GUIDE_SETTINGS.enabled,
    system: raw.system ?? DEFAULT_PAGE_GUIDE_SETTINGS.system,
    grid: normalizeGridGuideSettings(raw.grid),
  };
}

export function clampGridGuideValue(
  value: number,
  spec: { min: number; max: number; step: number },
): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return spec.min;
  const clamped = Math.min(spec.max, Math.max(spec.min, n));
  if (spec.step <= 0) return clamped;
  const steps = Math.round((clamped - spec.min) / spec.step);
  return spec.min + steps * spec.step;
}
